import { useState } from 'react'
import { Icon, IconButton, Input, Tooltip } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import * as R from 'ramda'

const defaultProps = {
  trigger: (
    <IconButton className="w-64 h-64">
      <Icon fontSize="large">search</Icon>
    </IconButton>
  ),
}

const useStyles = makeStyles((theme) => ({
  root: {},
  inputWrapper: {
    height: '100%',
    backgroundColor: theme.palette.primary.background,
  },
  input: {
    fontSize: '2rem',
    color: theme.palette.primary.subtitle,
  },
}))

function SearchBar(props) {
  const { formatMessage } = useIntl()

  const {
    searchText,
    onChange,
    onReset,
    trigger = defaultProps.trigger,
  } = props

  const classes = useStyles(props)
  const [search, setSearch] = useState(false)

  function showSearch() {
    setSearch(true)
    document.addEventListener('keydown', escFunction, false)
  }

  function hideSearch() {
    setSearch(false)
    onReset()
    document.removeEventListener('keydown', escFunction, false)
  }

  function escFunction(event) {
    // 27 is the key code for ESC
    if (event.keyCode === 27) {
      hideSearch()
    }
  }

  return (
    <div className={clsx(classes.root, 'flex', props.className)}>
      <Tooltip
        title={formatMessage({ id: 'searchBar.tooltip.text' })}
        placement="bottom"
      >
        <div data-testid="searchBtn" onClick={showSearch}>
          {trigger}
        </div>
      </Tooltip>

      {search && (
        <div
          className={clsx(
            classes.inputWrapper,
            'absolute left-0 right-0 top-0 bottom-0 z-9999 px-8 sm:px-24',
          )}
        >
          <div className="flex items-center w-full h-full">
            <Input
              placeholder={R.ifElse(
                R.isNil,
                R.always(props.placeholder),
                (searchFor) =>
                  formatMessage(
                    {
                      id: 'searchBar.placeholder.text',
                    },
                    { subject: searchFor },
                  ),
              )(props.searchFor)}
              className={clsx(
                classes.input,
                'flex flex-1 py-0 ltr:pr-16 rtl:pl-16 h-64',
              )}
              disableUnderline
              fullWidth
              value={searchText}
              inputProps={{
                'aria-label': 'Search',
                'data-testid': 'searchInput',
              }}
              onChange={onChange}
              autoFocus
            />

            <IconButton onClick={hideSearch} className="mx-8">
              <Icon>close</Icon>
            </IconButton>
          </div>
        </div>
      )}
    </div>
  )
}

SearchBar.propTypes = {
  searchText: PropTypes.string,
  onChange: PropTypes.func,
  onReset: PropTypes.func,
  placeholder: PropTypes.string,
  searchFor: PropTypes.string,
}

export default SearchBar
